import { render, staticRenderFns } from "./TextareaEditor.vue?vue&type=template&id=81598412&"
import script from "./TextareaEditor.vue?vue&type=script&lang=js&"
export * from "./TextareaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports